import { useState } from 'react';
import { FileUploadHookProps, FileUploadProps, OnDrop, UploadedFile } from './types';

export const useFileUpload = (
  onSuccess: any,
  onFileUploadError: FileUploadProps['onError']
): [OnDrop, FileUploadHookProps] => {
  const [files, setFiles] = useState<UploadedFile[]>([]);

  return [
    async (acceptedFiles) => {
      const [file] = acceptedFiles;

      const bodyFormData = new FormData();
      bodyFormData.append('mediafile', file);

      try {
        const reader = new FileReader();

        reader.onload = function () {
          const base64String = reader?.result;
          onSuccess(base64String, file);
        };
        reader.readAsDataURL(file);
        setFiles(file);
      } catch (error) {
        if (error && onFileUploadError) onFileUploadError(error);
      }
    },
    { files, setFiles },
  ];
};
